import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { alignRectangleDrawing, enablePolygonRightAngleSnapDrawing } from 'lib/leafletHelper.js';
import { MAX_ALLOWED_GRID_AREA } from 'constants/grid';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: markerIcon2x, iconUrl: markerIcon, shadowUrl: markerShadow });

L.drawLocal.draw.handlers.polygon.tooltip.start = '';
L.drawLocal.draw.handlers.polygon.tooltip.cont = '';
L.drawLocal.draw.handlers.polygon.tooltip.end = 'Hold Shift for 90° angles. Double click to end polygon.';
L.drawLocal.draw.handlers.rectangle.tooltip.start = '';

if (L.GeometryUtil?.readableArea) {
  const originalReadableArea = L.GeometryUtil.readableArea;
  L.GeometryUtil.readableArea = (area, isMetric, precision) => {
    if (!isMetric) {
      return originalReadableArea(area, isMetric, precision);
    }
    const precisionOptions = L.Util.extend({ m: 0 }, precision);
    const formatted = L.GeometryUtil.formattedNumber(area, precisionOptions.m);
    if (area > MAX_ALLOWED_GRID_AREA) {
      return `<span class="draw-area-too-high">${formatted} m²</span><br /><span class="draw-area-too-high-message">TOO LARGE!</span>`;
    }
    return `${formatted} m²`;
  };
}

if (L.Draw?.Polygon && !L.Draw.Polygon.prototype._umAreaPreviewPatched) {
  const originalVertexChanged = L.Draw.Polygon.prototype._vertexChanged;
  L.Draw.Polygon.prototype._vertexChanged = function (...args) {
    if (this.options.showArea) {
      const latLngs = this._poly?.getLatLngs?.();
      const polygonLatLngs = (Array.isArray(latLngs?.[0]) ? latLngs[0] : latLngs) as L.LatLng[] | undefined;
      this._area = polygonLatLngs && polygonLatLngs.length >= 2 ? L.GeometryUtil.geodesicArea(polygonLatLngs) : 0;
    }
    return originalVertexChanged.apply(this, args);
  };
  L.Draw.Polygon.prototype._umAreaPreviewPatched = true;
}

alignRectangleDrawing();
enablePolygonRightAngleSnapDrawing();
